const configs = {
    cornerImageInitialingDuration: 4,
    windowMediumSize: 700,
    windowSmallSize: 480,
    mouseCanvasSize: 50,
    particleSize: 7.5,
    particlesCount: 10,
    particleColor: "#F7EC09",
    subTitle: "Go-To Antistress Games",
    lettersAnimationDuration: 2.25,
    topCopyright: "Copyright © 2023 Free Software Foundation, Inc. <https://fsf.org/>",
    bottomCopyright: "Ghazaryan Arman",
}
export default configs;